/**
 * storyboards — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {LANDSCAPE, tagline, chips, type ToilePack} from './data'

export const storyboardsPack: ToilePack = {
    slug: 'storyboards',
    category: 'storyboard',
    name: 'Storyboards',
    tagline: tagline('boards', 'sequences', 'renderings'),
    chips: chips('sequences', 'renderings'),
    ratio: LANDSCAPE,
    readings: [
        {key: 'heist', label: 'Heist', subject: 'a van in an alley, a hand on a keypad, a vault door, headlights away'},
        {key: 'meetcute', label: 'Meet-cute', subject: 'two hands reaching for the last pastry, a pause, one small table'},
        {key: 'landing', label: 'Ship landing', subject: 'a ship through cloud, struts extending, a ramp lowering on a plain'},
    ],
    styles: [
        {key: 'pencil', label: 'Pencil rough', style: 'quick loose graphite, visible construction lines', palette: 'smudged tonal blocking on off-white', framing: 'six widescreen frames, 2×3, note strips'},
        {key: 'marker', label: 'Marker grayscale', style: 'ink outlines filled with five grey marker values', palette: 'crisp shadow shapes on white', framing: 'six widescreen frames, 2×3, note strips'},
        {key: 'color', label: 'Color frames', style: 'each frame a small finished key frame', palette: 'cinematic grading and atmosphere', framing: 'six widescreen frames, 2×3, note strips'},
    ],
    directions: ['a car chase instead', 'at night', 'closer coverage, more inserts'],
}
